import React from "react";
import cori2 from "../../images/cori2.JPG"

import "./author.css"

const Author = () => {
    return (
        <div className="about-the-author center-wrapper">
            <p>Corinne Beenfield loves writing, which considering that you are reading this, makes quite a bit of sense.<br/> She shares her home near the mountains with her three sons and daughter. She enjoys finding a random dirt path she's never been down, then stopping at some splotch of earth to explore with her children for hours. <br/>She writes women's fiction, often with a magical element. If you want to know when her upcoming books will be released, you can join her newsletter or follow her on Goodreads or Instagram.</p>
            <img className= "headshot" src={cori2} alt="Corinne Beenfield Author Headshot #2"/>

            <div className="author-links">
            <p> 
                <a href="https://blogspot.us20.list-manage.com/subscribe?u=2c473d9d403d8ea03a3f382d3&id=9a4978eedf" target= "_blank" rel="noreferrer">Newsletter</a>
            </p>
            <p>
               <a href="https://www.goodreads.com/author/show/18778744.Corinne_Beenfield" target= "_blank" rel="noreferrer">Good Reads</a>
            </p>
             <p>   
                <a href= "https://www.instagram.com/corinne_beenfield/?hl=en" target= "_blank" rel="noreferrer">Instagram Link</a>
            </p>
            </div>
        </div>

    )
}
export default Author;